const en = {
  loading: 'Loading advertisements...',
  loadFailed: 'Failed to load advertisements',
  invalidUrl: 'Invalid URL format',
  saveFailed: 'Failed to save advertisement',
  deleteFailed: 'Failed to delete advertisement',
  title: 'Advertisements',
  add: 'Add advertisement',
  overweightTitle: 'Total weight exceeds 1',
  overweightText: 'Ads further down the list show less often than their weight says. Keep the total at 1 or less.',
  chancesTitle: 'Display chances at app launch',
  /** Followed by the total, in bold */
  totalWeight: 'Total weight:',
  chancesEmpty: 'Add advertisements to configure display chances',
  /** An untitled ad, in the display chances */
  untitled: 'Untitled',
  /** The tooltip of an ad's share of the display chances bar; `chance` is already formatted */
  chanceTooltip: (name: string, chance: string) => `${name}: ${chance}%`,
  noAd: 'No advertisement',
  /** An untitled ad, in the list */
  untitledAd: 'Untitled Advertisement',
  weightValue: (weight: string) => `Weight: ${weight}`,
  chanceValue: (chance: string | undefined) => `(${chance ?? ''}% chance)`,
  percent: (value: string) => `${value}%`,
  newAd: 'New advertisement',
  editAd: 'Edit advertisement',
  titleLabel: 'Title',
  description: 'Description',
  link: 'Link',
  weight: 'Weight',
  weightHint: 'From 0 to 1: the chance to show at app launch',
  mainImage: 'Main image',
  mainImageHint: 'Shown in the advertisement popup',
  backgroundImage: 'Background image',
  backgroundImageHint: 'Shown behind the advertisement content',
  saving: 'Saving...',
  deleting: 'Deleting...',
};

const fr: typeof en = {
  loading: 'Chargement des publicités...',
  loadFailed: 'Impossible de charger les publicités',
  invalidUrl: 'Format d\'URL non valide',
  saveFailed: 'Impossible d\'enregistrer la publicité',
  deleteFailed: 'Impossible de supprimer la publicité',
  title: 'Publicités',
  add: 'Ajouter une publicité',
  overweightTitle: 'Le poids total dépasse 1',
  overweightText: 'Les publicités placées plus bas dans la liste s\'affichent moins souvent que leur poids ne l\'indique. Gardez un total de 1 au maximum.',
  chancesTitle: 'Probabilités d\'affichage au lancement de l\'app',
  totalWeight: 'Poids total\u00a0:',
  chancesEmpty: 'Ajoutez des publicités pour configurer les probabilités d\'affichage',
  untitled: 'Sans titre',
  chanceTooltip: (name: string, chance: string) => `${name}\u00a0: ${chance}\u00a0%`,
  noAd: 'Aucune publicité',
  untitledAd: 'Publicité sans titre',
  weightValue: (weight: string) => `Poids\u00a0: ${weight}`,
  chanceValue: (chance: string | undefined) => `(${chance ?? ''}\u00a0% de chances)`,
  percent: (value: string) => `${value}\u00a0%`,
  newAd: 'Nouvelle publicité',
  editAd: 'Modifier la publicité',
  titleLabel: 'Titre',
  description: 'Description',
  link: 'Lien',
  weight: 'Poids',
  weightHint: 'De 0 à 1\u00a0: la probabilité d\'affichage au lancement de l\'app',
  mainImage: 'Image principale',
  mainImageHint: 'Affichée dans la pop-up de la publicité',
  backgroundImage: 'Image d\'arrière-plan',
  backgroundImageHint: 'Affichée derrière le contenu de la publicité',
  saving: 'Enregistrement...',
  deleting: 'Suppression...',
};

const messages = { en, fr };
export default messages;
